import React from 'react';
import Header from '../../../../components/Header';
import FooterTwo from '../../../../components/Footer/index';
import StudyBreadcrumb from '../../../../components/Breadcrumb/outreach';
import ScrollToTop from '../../../../components/ScrollTop';
import point from '../../../../assets/images/icons/image.png';
import SideManu from './sidebar';
import SideManuDept from '../commonpages/sidebar-menu';

const Overview = () => {
    const department = 'pharmacy';

    return (
        <>
            <Header
                parentMenu='academics'
                menuCategoryEnable='enable'
            />
            <div class="react-wrapper background_height">
                <div class="react-wrapper-inner background_image">
                    <StudyBreadcrumb pageTitle="" />
                    <div className="high_quality-section pt---60 pb---120">
                        <div class="container ">
                            <SideManu />
                            <div class="row m-0">
                                <div class="col-md-12  col-sm-12 col-12 bg_color" style={{ backgroundColor: "#fff" }}>
                                    <div className="col-md-4 d-flex justify-content-end w-100">
                                        <SideManuDept department={department} />
                                    </div>
                                    <br/>
                                    <div class="container row">
                                        <div class="col-md-6">
                                            <b class="about__title wow animate__fadeInUp" data-wow-duration="0.5s" style={{ fontSize: "20px" }}><san className="hedingname_orange">Undergraduate (UG) </san> </b><br /><br />
                                            <div class="degree-list-container">
                                                <ul class="degree-list">
                                                    <li><span class="icon"><img className='pointimage' src={point} /></span><span>B.Pharmacy </span></li>
                                                    <li><span class="icon"><img className='pointimage' src={point} /></span><span>Pharm.D    </span></li>
                                                </ul>
                                            </div>
                                        </div>



                                        <div class="col-md-6">
                                            <b class="about__title wow animate__fadeInUp" data-wow-duration="0.5s" style={{ fontSize: "20px" }}><san className="hedingname_orange">Postgraduate  (PG) </san> </b><br /><br />
                                            <div class="degree-list-container">
                                                <ul class="degree-list">
                                                    <li><span class="icon"><img className='pointimage' src={point} /></span><span>M.Pharmacy (Pharmaceutics)</span></li>
                                                    <li><span class="icon"><img className='pointimage' src={point} /></span><span>M.Pharmacy (Pharmaceutical Analysis)  </span></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ScrollToTop />
                </div>
            </div>
            <FooterTwo />
        </>
    );
}

export default Overview;